import Check from '@mui/icons-material/Check'
import Close from '@mui/icons-material/Close'

export interface CheckOrCloseProps {
    check: boolean
    disabled?: boolean
}

function CheckOrClose({ check, disabled }: CheckOrCloseProps) {
    return check ? (
        <Check color={disabled ? 'disabled' : 'primary'} sx={{ mb: '-5px' }} />
    ) : (
        <Close color={disabled ? 'disabled' : 'error'} sx={{ mb: '-5px' }} />
    )
}

export default CheckOrClose
